import React, { FC } from "react";
import "./WsDepotCardsList.scss";
import { CardHeader } from "@shared/ui/card-header";
import { useNavigate } from "react-router-dom";
import { useWindows } from "@app/overlay";
import { OPEN_FILTER_QUERY_PARAM } from "@app/router/queryParams";
import { BusinessList } from "@src/components/business-list";
import { BusinessDivisionValue, BusinessMeasureValue, BusinessStockObjValue } from "@src/components/business-data-display";
import { ListItem } from "@src/components/business-list";
import { useBusinessListQuery } from "@src/hooks/useBusinessListQuery";
import { useUrlFilter } from "@shared/hooks/useUrlFilter";
import { useUrlParamTrigger } from "@shared/hooks/useUrlParamTrigger";
import { wsDepotCardsServices, type WsDepotCard, type WsDepotCardFilter } from "../../../../api/wsDepotCards";
import { wsDepotCardsListWindows } from "./wsDepotCardsList.windows";
import { AppPaths } from "@src/router";

const WsDepotCardsList: FC = () => {
    const navigate = useNavigate();
    const windows = useWindows();
    const filterState = useUrlFilter<WsDepotCardFilter>();

    const list = useBusinessListQuery<WsDepotCard, WsDepotCardFilter>({
        queryKey: "workshop.wsDepotCards",
        filter: filterState.filter,
        queryFn: async (flt, signal) => {
            return wsDepotCardsServices.load(
                { flt, include: ["Division", "DivisionSection", "Stockobj", "Measure", "ProductionType"] },
                { signal },
            );
        },
        getId: (item) => item.Code,
    });

    const openFilterWindow = (): void => {
        wsDepotCardsListWindows.filter.open(windows, {
            initialFilter: filterState.filter,
            onApply: (flt) => {
                filterState.applyFilter(flt, true);
            },
        });
    };

    useUrlParamTrigger(OPEN_FILTER_QUERY_PARAM, () => {
        openFilterWindow();
    });

    return (
        <div className="ws_depot_cards_list_page">
            <CardHeader
                text={"Цех. номенклатура"}
                buttons={[
                    { type: "button", text: "Поиск", srcIcon: "/images/common/options.svg", onClick: openFilterWindow },
                ]}
            />
            <BusinessList list={list} onOpenFilter={openFilterWindow}>
                {list.data.map((item) => (
                    <ListItem
                        key={item.Code}
                        title={`Номенклатура цеха №${item.Num}`}
                        props={[
                            {
                                label: "Подразделение",
                                value: <BusinessDivisionValue division={item.Division} section={item.DivisionSection} />,
                            },
                            { label: "Номенклатура", value: <BusinessStockObjValue stockObj={item.Stockobj} /> },
                            {
                                label: "Остаток",
                                value: <BusinessMeasureValue value={item.Remainder} measure={item.Measure} />,
                            },
                        ]}
                        onClick={() => {
                            navigate(AppPaths.WORKSHOP.DEPOT.CARD(item.Code.toString()));
                        }}
                    />
                ))}
            </BusinessList>
        </div>
    );
};

export default WsDepotCardsList;
